import React, {useState, useEffect, useContext} from 'react'
import {BasketContext} from '../context'

const BasketIndicator = () => {
  const [amount, setAmount] = useState(0);
  const [basketAnimationClass, setBasketAnimationClass] = useState('');
  const {basket} = useContext(BasketContext);

  useEffect(() => {
    const newCount = basket.reduce((sum, {amount}) => sum += amount, 0);
    setAmount(newCount);
  },[basket]);

  useEffect(() => {
    if (window.pageYOffset > 100) {
      window.scrollTo(0, 0);
    }
    setBasketAnimationClass('basket-animation');

    const timeout = setTimeout(() => {
      setBasketAnimationClass('')
    }, 3000);

    return () => {
      clearTimeout(timeout);
      setBasketAnimationClass('')
    }
  },[amount]);

  return (
    <div className={`header-main__pic_basket${amount > 0 ? '_full' : ''} ${basketAnimationClass}`}>
      {amount > 0 && amount}
    </div>
  )
};

export default BasketIndicator
